import { FC } from 'react'
import { Chip, Tooltip } from '@mui/material'
import {
  ROTULO_RESULTADO_ELEGIBILIDADE,
  ROTULO_ROTA_OPERACAO,
  ResultadoElegibilidade,
  RotaOperacao,
  TOOLTIP_AVALIACAO_ORIGINEI,
} from '@/types/elegibilidade'

/**
 * P2 (AN-PP2 §8): chips da elegibilidade — só RÓTULO do resultado que o servidor devolveu.
 * Nenhuma regra aqui: cor e texto são função do `resultado`/`rota` recebidos.
 */

export const COR_RESULTADO_ELEGIBILIDADE: Readonly<
  Record<ResultadoElegibilidade, 'success' | 'warning' | 'info' | 'default'>
> = {
  ATENDE: 'success',
  NAO_ATENDE: 'warning',
  DADOS_INSUFICIENTES: 'warning',
  AVALIACAO_ORIGINEI: 'info',
  SEM_POLITICA: 'default',
}

export const ChipResultadoElegibilidade: FC<{
  resultado: ResultadoElegibilidade
  /** Texto do tooltip (ex.: a mensagem da explicação). */
  detalhe?: string | null
  size?: 'small' | 'medium'
}> = ({ resultado, detalhe, size = 'small' }) => {
  const tooltip = resultado === 'AVALIACAO_ORIGINEI' ? TOOLTIP_AVALIACAO_ORIGINEI : detalhe ?? ''
  const chip = (
    <Chip
      size={size}
      color={COR_RESULTADO_ELEGIBILIDADE[resultado]}
      variant={resultado === 'ATENDE' ? 'filled' : 'outlined'}
      label={ROTULO_RESULTADO_ELEGIBILIDADE[resultado] ?? resultado}
    />
  )
  return tooltip ? <Tooltip title={tooltip}>{chip}</Tooltip> : chip
}

/** Chip "Grandes Operações" (só aparece para essa rota; a rota padrão não ganha chip). */
export const ChipRotaOperacao: FC<{
  rota: RotaOperacao | null | undefined
  /** Mostra também a rota PADRÃO (detalhe da reserva). */
  mostrarPadrao?: boolean
  size?: 'small' | 'medium'
}> = ({ rota, mostrarPadrao = false, size = 'small' }) => {
  if (!rota || (rota === 'PADRAO' && !mostrarPadrao)) return null
  return (
    <Chip
      size={size}
      color={rota === 'GRANDES_OPERACOES' ? 'secondary' : 'default'}
      variant={rota === 'GRANDES_OPERACOES' ? 'filled' : 'outlined'}
      label={rota === 'GRANDES_OPERACOES' ? ROTULO_ROTA_OPERACAO.GRANDES_OPERACOES : `Rota ${ROTULO_ROTA_OPERACAO.PADRAO}`}
    />
  )
}
